module.exports = __webpack_public_path__ + "img/home.485f6305.jpg";